// в localStorage страна кладётся через setItem, поэтому отсутствующее значение
// может лежать там строкой 'undefined' — такое считаем «страна неизвестна»
const normalize = (country) =>
  !country || country === 'undefined' || country === 'null' ? null : country;

export const getAuthUserCountry = (currentCustomer, currentAdvisor) => {
  if (!currentCustomer?.country && !currentAdvisor?.country) {
    return normalize(localStorage.getItem('AUTH_USER_COUNTRY'));
  }
  return normalize(currentAdvisor?.country || currentCustomer?.country);
};
